import React from 'react';
import { withHighcharts } from 'react-highcharts-wrapper';
import { merge } from 'lodash';
import { connect } from 'react-redux';
import { addExportConfig, updateExportConfig, destroyExportConfig } from 'services/exports/duck';

class AbstractChart extends React.PureComponent {
    constructor(props) {
        super(props);
        this.printMediaQueryListener = this.printMediaQueryListener.bind(this);
    }

    printMediaQueryListener(mql) {
        if (mql.matches) { // Printing.
            const config = merge({}, this.props.config, {
                plotOptions: {
                    series: {
                        animation: false
                    }
                },
                chart: {
                    animation: false
                }
            });

            if (this.chartEl) {
                this.props.service.update(config, this.chartEl);
            }
        } else if (this.chartEl) {
            this.props.service.update(this.props.config, this.chartEl);
        }
    }

    componentDidMount() {
        this.props.service.create(this.props.config, this.chartEl);

        if (window.matchMedia) {
            const mediaQueryList = window.matchMedia('print');
            mediaQueryList.addListener(this.printMediaQueryListener);
        }
    }

    componentDidUpdate() {
        this.props.service.update(this.props.config, this.chartEl);
    }

    componentWillUnmount() {
        if (window.matchMedia) {
            const mediaQueryList = window.matchMedia('print');
            mediaQueryList.removeListener(this.printMediaQueryListener);
        }

        this.props.service.destroy();
    }

    render() {
        const _this2 = this;

        return React.createElement('div', {
            ref: function ref(el) {
                _this2.chartEl = el;
                return _this2.chartEl;
            }
        });
    }
}


const ConnectedAbstractChart = withHighcharts(props => <AbstractChart ref={props.forwardRef} {...props} />);
const WrappedAbstractChart = React.forwardRef((props, ref) => (
    <ConnectedAbstractChart forwardRef={ref} {...props} />
));

class ExportableChart extends React.Component {
    constructor(props) {
        super(props);

        if (!props.exportName) {
            console.warn('ExportableChart: Missing exportName.'); // eslint-disable-line no-console
        }
    }

    componentDidMount() {
        if (this.props.exportName) {
            this.props.addExportConfig({
                exportName: this.props.exportName,
                type: 'chart',
                config: this.props.config
            });
        }
    }

    componentDidUpdate() {
        if (this.props.exportName) {
            this.props.updateExportConfig({
                exportName: this.props.exportName,
                type: 'chart',
                config: this.props.config
            });
        }
    }

    componentWillUnmount() {
        if (this.props.exportName) {
            this.props.destroyExportConfig({
                exportName: this.props.exportName
            });
        }
    }

    render() {
        const config = this.props.config;

        return (
            <WrappedAbstractChart ref={this.props.forwardRef} config={config} />
        );
    }
}

const ConnectedExportableChart = connect(null, {
    addExportConfig,
    updateExportConfig,
    destroyExportConfig
})(ExportableChart);

const WrappedExportableChart = React.forwardRef((props, ref) => (
    <ConnectedExportableChart forwardRef={ref} {...props} />
));


export {
    // Matching 'react-highcharts-wrapper' api in returning AbstractChart
    WrappedExportableChart as default,
    WrappedExportableChart as AbstractChart, // eslint-disable-line import/prefer-default-export
    // exposing non-connected components for testing.
    ExportableChart,
    AbstractChart as AbstractChartPristine,
};



// WEBPACK FOOTER //
// ./src/containers/charts/AbstractChart.js